import React from 'react'
import Pt from 'prop-types'
import { FormControl } from 'react-bootstrap'
import Ipt from 'react-immutable-proptypes'
import Autosuggest from 'react-autosuggest'

import '../Autocomplete.css'
import Suggestion from './Suggestion'

export default function AddressAutocomplete({
  alwaysRenderSuggestions = false,
  className = 'form-control',
  focusFirstSuggestion = false,
  // eslint-disable-next-line no-underscore-dangle
  getSuggestionValue = s => s.formattedAddress,
  onSuggestionSelected,
  onSuggestionsClearRequested = () => {},
  onSuggestionsFetchRequested,
  renderInput = props => <FormControl {...props} />,
  suggestions,
  ...inputProps
}) {
  inputProps.className = className

  return (
    <div className="address-autocomplete autocomplete-container">
      <Autosuggest
        alwaysRenderSuggestions={alwaysRenderSuggestions}
        focusFirstSuggestion={focusFirstSuggestion}
        focusInputOnSuggestionClick={false}
        getSuggestionValue={getSuggestionValue}
        inputProps={inputProps}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionSelected={onSuggestionSelected}
        renderInputComponent={renderInput}
        renderSuggestion={s => <Suggestion s={s} />}
        suggestions={suggestions.toArray()}
      />
    </div>
  )
}

AddressAutocomplete.propTypes = {
  alwaysRenderSuggestions: Pt.bool,
  className: Pt.string,
  focusFirstSuggestion: Pt.bool,
  getSuggestionValue: Pt.func,
  onSuggestionSelected: Pt.func.isRequired,
  onSuggestionsClearRequested: Pt.func,
  onSuggestionsFetchRequested: Pt.func.isRequired,
  renderInput: Pt.func,
  suggestions: Ipt.orderedSet.isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/AddressAutocomplete/index.jsx